import { Box, Button, FormControl, FormHelperText, FormLabel, Stack } from "@mui/material";
import { Form, Field, FormikProvider, useFormik } from "formik";
import { TextField } from "formik-mui";
import * as yup from "yup";

export function AddNewSegmentForm(props) {
    const { kpi, handleAddNewSegment, handleOnCloseForm, ...restProps } = props;
    const kpiData = kpi?.data?.data;

    // setup formik
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            title:
                kpiData?.title +
                (kpiData?.kpi_data_segments?.length > 0 ? ` (${kpiData?.kpi_data_segments?.length + 1})` : ""),
        },
        validationSchema: yup.object().shape({
            title: yup.string().required(),
        }),
        // checking.
        onSubmit: async (values, { setSubmitting, resetForm }) => {
            try {
                setSubmitting(true);
                await handleAddNewSegment(kpiData?.id, values).unwrap();
                setSubmitting(false);
                resetForm();
            } catch (error) {
                // console.error(error);
            }
        },
        onReset: () => {
            // callback
            if (handleOnCloseForm instanceof Function) {
                handleOnCloseForm();
            }
        },
    });
    const { touched, errors } = formik;

    return (
        <FormikProvider value={formik}>
            <Form>
                <Stack spacing={3}>
                    <FormControl required fullWidth>
                        <FormLabel>ชื่อ segment</FormLabel>
                        <Field component={TextField} name="title" />
                        <FormHelperText name="title" touched={touched} errors={errors} />
                    </FormControl>
                    {/** form here */}

                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <Button type="submit" variant="contained" disabled={formik.isSubmitting}>
                            Save
                        </Button>
                        <Button type="reset" disabled={formik.isSubmitting}>
                            Cancel
                        </Button>
                    </Box>
                </Stack>
            </Form>
        </FormikProvider>
    );
}
